import { Box, Center, Divider, HStack, Img, Stack, Text, VStack, VisuallyHidden, chakra } from '@chakra-ui/react'
import React from 'react'
import { FaEnvelope, FaLinkedin } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import img from "../../Assets/Images/photo.jpg";
import sir from "../../Assets/Images/Sir.jpg";

const SocialButton = ({
  children,
  label,
  href,
}) => {
  return (
    <chakra.button
      bg={"blackAlpha.100"}
      rounded={'full'}
      w={8}
      h={8}
      cursor={'pointer'}
      as={'a'}
      href={href}
      display={'inline-flex'}
      alignItems={'center'}
      justifyContent={'center'}
      transition={'background 0.3s ease'}
      _hover={{
        bg: 'blackAlpha.200',
      }}>
      <VisuallyHidden>{label}</VisuallyHidden>
      {children}
    </chakra.button>
  );
};
function LeaderShip() {
  let navigate = useNavigate();
  const handleContactUs = () => {
    navigate("/contactus");
  };
  const description = {
    fontSize: "18px",
    color: "#1F508B",
    mb: "1.75em",
    as: "p"
  };
  const headingStyle = {
    color: "#1F508B",
    fontSize: "30px",
    fontWeight: "300",
    lineHeight: "1.5rem"
  };
  const subheadingStyle = {
    color: "#1F508B",
    fontSize: "22px",
    fontWeight: "300",
    lineHeight: "1.5rem"
  };
  return (
    <>
      <Center>
        <Stack maxW={"1010px"} alignItems={"center"}>
          <Box textAlign={"center"}>
            <Text {...headingStyle}>A Team with the Right Experience -</Text>
            <Text {...headingStyle} mt={"18px"}>Let Us Help You with Your Tokenized Real Estate Investment</Text>
            <Center>
              <Divider alignItems={"center"} mt={"40px"} mb={"10px"} width={"25%"} borderColor={"#1F508B"} /> </Center>
          </Box>
          <Box mb={"20px"} mt={"20px"} textAlign={"center"}>
            <Text {...description}>Every tokenized real estate Investment opportunity that comes to Asset Tokenization is reviewed and analyzed by our team who have over 65 years of combined private equity real estate and technology commerce experience. This combined experience has helped us conduct over $7B in transactions and we have conducted over $3 Billion in acquisitions, dispositions, and private equity transactions. Our expertise in digital technology and blockchain makes us the #1 choice for providing security token capital market solutions. Investing in commercial real estate has never been easier with a great team.</Text>
            <Text {...description}>If you have any questions for the team, please <Text as="span" cursor="pointer" fontWeight={"bold"} onClick={handleContactUs}>contact us</Text></Text>
          </Box>
          <Box>
            <Center>
              <Box flexDirection={"column"}>
                <Text {...headingStyle}>Leadership</Text>
                <Divider alignItems={"center"} mt={"30px"} mb={"60px"} borderColor={"#1F508B"} />
              </Box>
            </Center>
            <Stack align={"center"} direction={"row"} spacing={14} mb={"50px"}>
              <VStack>
                <Img boxShadow={"lg"} borderRadius='full' boxSize='180px' alt='ceo' border={"12px solid white"} src={img} _hover={{ transform: "scale(1.1)", transition: "transform 0.3s ease" }} />
                <Text {...subheadingStyle} mt={"20px"}>Zaid Munir</Text>
                <Text {...subheadingStyle} mt={"1px"}>CEO</Text>
                <Text as="p" textAlign={"center"} fontSize="16px" color="#1F508B">Zaid Munir has 17 years experience with brokerage and client advisory services working with Colliers International, and for the past 15 years, as Cushman and Wakefield’s Executive Director of Capital Markets Group. He is one of Houston’s repeat top performers with over $2 billion in successful transactions. Prior to his CRE career, Edward was a successful Silicon Valley entrepreneur who founded and exited a venture-backed startup he built for $100M to a Fortune 500 Company.</Text>
                <Divider mt={"45px"} borderColor={"#4B4F58"} />
                <HStack mt={"10px"}>
                  <SocialButton label={'mail'} href={'#'}>
                    <FaEnvelope />
                  </SocialButton>
                  <SocialButton label={'Linkdin'} href={'#'}>
                    <FaLinkedin />
                  </SocialButton>
                </HStack>
              </VStack>
              <VStack>
                <Img boxShadow={"lg"} borderRadius='full' boxSize='180px' alt='coo' border={"12px solid white"} src={sir} _hover={{ transform: "scale(1.1)", transition: "transform 0.3s ease" }} />
                <Text {...subheadingStyle} mt={"20px"}>Abde Munib</Text>
                <Text {...subheadingStyle} mt={"1px"}>COO</Text>
                <Text textAlign={"center"} as="p" fontSize="16px" color="#1F508B">Abde Munib has 17 years experience with brokerage and client advisory services working with Colliers International, and for the past 15 years, as Cushman and Wakefield’s Executive Director of Capital Markets Group. He is one of Houston’s repeat top performers with over $2 billion in successful transactions. Prior to his CRE career, Edward was a successful Silicon Valley entrepreneur who founded and exited a venture-backed startup he built for $100M to a Fortune 500 Company.</Text>
                <Divider mt={"45px"} borderColor={"#4B4F58"} />
                <HStack mt={"10px"}>
                  <SocialButton label={'mail'} href={'#'}>
                    <FaEnvelope />
                  </SocialButton>
                  <SocialButton label={'Linkdin'} href={'#'}>
                    <FaLinkedin />
                  </SocialButton>
                </HStack>
              </VStack>
            </Stack>
          </Box>
        </Stack>
      </Center>
      <Divider mb={"20px"} />
    </>
  )
}

export default LeaderShip